import styled from "styled-components";
import { FiPause, FiPlay } from "react-icons/fi";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid currentColor;
  border-radius: 50%;
  background: #173f86;
  color: #ffffff;
  border-color: #173f86;
  cursor: pointer;
  z-index: 12;

  &:focus-visible {
    outline: 2px solid #173f86;
    outline-offset: 3px;
  }
`;

export default function PlaybackButton({ paused, onClick, label, style }) {
  const action = `${paused ? "Resume" : "Pause"} ${label}`;
  return (
    <Button type="button" onClick={onClick} aria-label={action}
      aria-pressed={paused} title={action} style={style} data-print-hide>
      {paused ? <FiPlay size={15} aria-hidden="true" /> : <FiPause size={15} aria-hidden="true" />}
    </Button>
  );
}
